const fetchToDoBricks = (country) => {

    return axios.post('api/invoices/todobricks', {country: country})
        .then(response => {
            return response
        })
        .catch(error => {
            return error
        })

}

const fetchInvoicesList = (conditions) => {

    return axios.post('api/invoices/list', {conditions: conditions})
        .then(response => {
            return response
        })
        .catch(error => {
            return error
        })
}

const updateInvoice = (invoices, data) => {

    return axios.post('api/invoices/update', { invoices:invoices, data: data })
        .then(response => {
            return response
        })
        .catch(error => {
            return error
        })

}

export default {
    fetchToDoBricks,
    fetchInvoicesList,
    updateInvoice
}
